<template>
  <wizard-form v-bind="ouiaProps" :hidden="hidden" :title="$t('Trasferimento')">
    <wizard-question-yesno
      :title="$t('Attivazione: questo servizio è?')"
      name="new_service"
      v-model="wizard.newService"
      :label-yes="$t('Una nuova attivazione')"
      :label-no="$t('Un servizio già esistente da trasferire su Artera')"
      required
    />

    <pf-flex>
      <pf-flex-item>
        <wizard-question-yesno
          v-if="wizard.askSiteTransfer && wizard.newService === false"
          :title="$t('Vuoi che ci occupiamo noi del trasferimento del sito web?')"
          :tooltip="$t('Al termine dell\'ordine ti chiederemo tutti i dati necessari per effettuare il trasferimento dall\'attuale provider')"
          name="site_transfer"
          v-model="wizard.siteTransfer"
          required
        />
      </pf-flex-item>
      <pf-flex-item>
        <wizard-question-yesno
          v-if="wizard.askMailTransfer && wizard.newService === false"
          :title="$t('Vuoi che ci occupiamo noi del trasferimento delle mail?')"
          :tooltip="$t('Al termine dell\'ordine ti chiederemo di fornirci l\'attuale server IMAP e la lista delle caselle attive con le relative password')"
          name="mail_transfer"
          v-model="wizard.mailTransfer"
          required
        >
          <small v-if="wizard.askMailTransfer && wizard.newService === false">{{
            $t("IMPORTANTE: per poter procedere con il trasferimento delle caselle mail è necessario che il servizio IMAP sia attivo sull'attuale provider")
          }}</small>
        </wizard-question-yesno>
      </pf-flex-item>
    </pf-flex>

    <wizard-question-yesno
      v-if="wizard.askExtraTimeTransfer"
      :title="$t('Occorre effettuare trasferimento al di fuori dell\'orario di ufficio (in serata o durante il weekend)?')"
      name="extra_time_transfer"
      v-model="wizard.extraTimeTransfer"
      required
      first-no
    >
      <template #label-no>
        {{ $t('No') }}
        <wizard-price-tag />
      </template>
      <template #description-no>
        {{ $t('Una volta ricevuti tutti i dati per procedere effettueremo il trasferimento in orario di ufficio') }}
      </template>

      <template #label-yes>
        {{ $t('Sì') }}
        <wizard-price-tag :product="wizard.getProdotto(wizard.codiciProdottiAddon.extraTimeTransferProduct)" />
      </template>
      <template #description-yes>
        {{ $t('Pianificheremo con te la migrazione affinché venga eseguita al di fuori degli orari d’ufficio.') }}
      </template>
    </wizard-question-yesno>
  </wizard-form>
</template>

<script lang="ts" setup>
import { useOUIAProps, type OUIAProps } from '@common/ouia';
import { useWizardStep } from '@/wizard';

import wizardQuestionYesno from '../questions/wizard-question-yesno.vue';
import WizardForm from '../wizard-form.vue';
import wizardPriceTag from '../wizard-price-tag.vue';

defineOptions({
  name: 'WizardStepTrasferimenti',
});

const props = defineProps<OUIAProps>();
const ouiaProps = useOUIAProps(props);

const { wizard, hidden, isEnabled } = useWizardStep({
  isEnabled: wizard => wizard.askSiteTransfer || wizard.askMailTransfer,
});

defineExpose({
  isEnabled,
});
</script>
